<div class="offcanvas offcanvas-bottom show" data-bs-scroll="true" data-bs-backdrop="false"
   *ngIf="callChatStatus.length>0"  tabindex="-1" id="offcanvasBottom" aria-labelledby="offcanvasBottomLabel">
    <!-- <div class="offcanvas-header">
      <h5 class="offcanvas-title" id="offcanvasBottomLabel">Offcanvas bottom</h5>
      <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div> -->
    <div class="offcanvas-body small">
        <div *ngFor="let item of callChatStatus">
            <div class="queueStrip row">
                <div class="col-md-1 w-px">
                    <img class="astrologerProfile rounded rounded-full " src="{{item?.data?.astrologerProfile}}" alt="Best astrologers">
                </div>
                <div class="col-md-7 col-xs-7">
                    <div class="col-md-12 col-xs-12 ">
                        Astrologer- {{item?.data?.astrologerName}}
                    </div>
                    <div class="col-md-12 col-xs-12 ">
                        <div class="mgtpp" style="color: red">
                            <p style="color:green">{{item?.data?.viewMessage}}</p>
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-xs-2">
                    <div class="row">
                        <div class="col-md-12   col-xs-12" style="margin-top: 1em;">
                            <div *ngIf="item?.data?.serviceStatus && item?.data?.serviceStatus!='IN_PROGRESS'">
                                <a href="javascript:void(0)"
                                    *ngIf="item?.data?.serviceStatus && item?.data?.serviceStatus=='WAITING' ; else elseButton"
                                    style="width: 100%;" class="btndngr cancelQueue btn btn-rounded btn-warning"
                                    data-name="" data-id="">
                                    <div class="newwtbtn" (click)="cancelChatCall()">Try Again</div>
                                </a>
                                <ng-template #elseButton>
                                    <a href="javascript:void(0)" style="width: 100%;" class="btndngr cancelQueue"
                                        data-name="" data-id="">
                                        <div class="newwtbtn">Try Again</div>
                                    </a>
                                </ng-template>
                            </div>
                            <div *ngIf="item?.showBtn">
                                <a *ngIf="(item?.data?.serviceStatus && item?.data?.serviceStatus=='IN_PROGRESS')"
                                    class="clsAccept btn btn-rounded btn-success" (click)="acceptChat(item)"
                                    style="width: 100%;">
                                    <div class="newwtbtn nbcls">{{item?.btnMessage}}</div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>